import { useAuthStore } from '@/stores/auth.store'
import { useWorkspaceStore } from '@/stores/workspace.store'

export function useWorkspace() {
  const workspaceStore = useWorkspaceStore()
  const { workspaces } = useAuthStore()

  return {
    currentWorkspaceId: workspaceStore.currentWorkspaceId,
    currentWorkspaceName: workspaceStore.currentWorkspaceName,
    workspaces,
    setWorkspace: workspaceStore.setWorkspace,
    clearWorkspace: workspaceStore.clearWorkspace,
  }
}